<template>
    <div class="h-full border-r overflow-y-scroll">

        <sub-menu
            :links="links"
            header="Lasting Power of Attorney"
        ></sub-menu>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubMenu from '@/components/menu/SubMenu.vue'
import menus from '@/utils/menus'

export default defineComponent({
    name: 'LpaSidebar',
    components: {
        SubMenu
    },
    setup() {
        const { lpaSidebarLinks } = menus();

        return {
            links: lpaSidebarLinks,
        }
    }  
})
</script>